import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
	AUTH_TOKEN,
	SIGNIN,
	SIGNOUT,
	SIGNUP,
	SIGNIN_WITH_GOOGLE,
	SIGNIN_WITH_FACEBOOK,
	AUTH_REFRESH_TOKEN,
	REFRESH_TOKEN
} from '../constants/Auth';
import {
	showAuthMessage,
	authenticated,
	signOutSuccess,
	signUpSuccess,
	signInWithGoogleAuthenticated,
	signInWithFacebookAuthenticated,
	refreshTokenSuccess
} from "../actions/Auth";

import FirebaseService from 'services/FirebaseService'
import { loginWithFormService, refreshTokenService } from 'redux/services/Auth';

export function* signInWithFBEmail() {
  yield takeEvery(SIGNIN, function* ({payload}) {
		try {
			const data = yield call(loginWithFormService, payload);
			if (data.message) {
				yield put(showAuthMessage(data.message));
			} else {
				localStorage.setItem(AUTH_TOKEN, data.jwt);
				localStorage.setItem(AUTH_REFRESH_TOKEN, data.refresh_token);
				yield put(authenticated(data.jwt, data.refresh_token));
			}
		} catch (err) {
			yield put(showAuthMessage(err));
		}
	});
}

export function* signOut() {
  yield takeEvery(SIGNOUT, function* () {
		try {
			const signOutUser = yield call(FirebaseService.signOutRequest);
			if (signOutUser === undefined) {
				localStorage.removeItem(AUTH_TOKEN);
				localStorage.removeItem(AUTH_REFRESH_TOKEN);
				yield put(signOutSuccess(signOutUser));
			} else {
				yield put(showAuthMessage(signOutUser.message));
			}
		} catch (err) {
			yield put(showAuthMessage(err));
		}
	});
}

export function* signUpWithFBEmail() {
  yield takeEvery(SIGNUP, function* ({payload}) {
		const {email, password} = payload;
		try {
			const user = yield call(FirebaseService.signUpEmailRequest, email, password);
			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				localStorage.setItem(AUTH_TOKEN, user.user.uid);
				yield put(signUpSuccess(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error));
		}
	}
	);
}

export function* refreshToken() {
	yield takeEvery(REFRESH_TOKEN, function* () {
		  try {
			  const data = yield call(refreshTokenService);
			  if (data.message) {
				  console.log(data);
				  yield put({ type: SIGNOUT });
			  } else {
				  localStorage.setItem(AUTH_TOKEN, data.jwt);
				  localStorage.setItem(AUTH_REFRESH_TOKEN, data.refresh_token);
				  yield put(refreshTokenSuccess(data.jwt, data.refresh_token));
			  }
		  } catch (error) {
			  console.log(error);
			  yield put({ type: SIGNOUT });
		  }
	  });
}

export function* signInWithFBGoogle() {
  yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
		try {
			const user = yield call(FirebaseService.signInGoogleRequest);
			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				localStorage.setItem(AUTH_TOKEN, user.user.uid);
				yield put(signInWithGoogleAuthenticated(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error));
		}
	});
}

export function* signInWithFacebook() {
  yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
		try {
			const user = yield call(FirebaseService.signInFacebookRequest);
			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				localStorage.setItem(AUTH_TOKEN, user.user.uid);
				yield put(signInWithFacebookAuthenticated(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error));
		}
	});
}

export default function* rootSaga() {
  yield all([
		fork(signInWithFBEmail),
		fork(signOut),
		fork(signUpWithFBEmail),
		fork(refreshToken),
		fork(signInWithFBGoogle),
		fork(signInWithFacebook)
  ]);
}
